import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface DropdownItemBadgesProps {
  renderAsSecondaryContent?: boolean;

  children?: ReactNode;
}

interface DropdownItemBadgeProps {
  color: string;
  backgroundColor: string;

  children?: ReactNode;
}

/*
 * Style.
 */

const StyledBadgesDiv = styled.div<{$renderAsSecondaryContent: boolean}>`
  grid-area: ${(p) => (p.$renderAsSecondaryContent ? 'secondary-content' : 'badges')};
  margin: 0 6px;

  display: flex;
  gap: 4px;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  min-width: max-content;
`;

const StyledBadgeDiv = styled.div<{$color: string; $backgroundColor: string}>`
  padding: 2px 5px;

  font-size: ${fontSizes.veryTiny};
  font-weight: ${fontWeights.bold};

  border-radius: 100px;

  & > div {
    transform: translateY(-0.5px);
  }

  color: ${(p) => p.$color};
  background-color: ${(p) => p.$backgroundColor};
`;

/*
 * Components.
 */

export const DropdownItemBadges: FC<DropdownItemBadgesProps> = (props) => {
  const {children} = props;

  return (
    <StyledBadgesDiv $renderAsSecondaryContent={Boolean(props.renderAsSecondaryContent)}>
      {children}
    </StyledBadgesDiv>
  );
};

export const DropdownItemBadge: FC<DropdownItemBadgeProps> = (props) => {
  const {children, color, backgroundColor} = props;
  return (
    <StyledBadgeDiv $color={color} $backgroundColor={backgroundColor}>
      {children}
    </StyledBadgeDiv>
  );
};
